module.exports = __webpack_public_path__ + "fonts/Flaticon.eot?8bd332ceec1f4118aef99e6cc46ea9af";